import { select, takeLeading, ThunkCtx } from "starfx";

import { identityACtx, isOk, safeLast } from "../helpers";
import { schema } from "../schema";
import { xThunk } from "../xapis";

import type { TUIFiscalBook } from "../schema/uiFiscalBooks.def";
import type { Next } from "starfx";

const db = schema;
export const setCurrenFiscalBookId = xThunk.create<Partial<TUIFiscalBook>>(
  "/xthunks/uiFiscalBooks/setCurrentFiscalBookId",
  { supervisor: takeLeading },
  function* (ctx: ThunkCtx, next: Next) {
    const fbState = yield* select(db.uiFiscalBooks.select);
    const newState = { ...fbState, ...ctx.payload };
    yield* schema.update(db.uiFiscalBooks.set(newState));
    yield* next();
  }
);
